module.exports = __webpack_public_path__ + "img/test-9-11-1.ec282124.png";